import clsx from 'clsx';
import React, { ReactNode } from 'react';

import styles from './TextBlock.module.scss';

export interface TextBlockProps {
  title?: string;
  text?: ReactNode;
  helpText?: string;
  children?: ReactNode;
  className?: string;
}

export const TextBlock = ({
  title,
  text,
  helpText,
  children,
  className,
  ...rest
}: TextBlockProps) => (
  <div className={clsx(styles.textBlockRoot, className)} {...rest}>
    {title && <p className={styles.title}>{title}</p>}
    {text && <div className={styles.text}>{text}</div>}
    {helpText && <p className={styles.helpText}>{helpText}</p>}
    {children}
  </div>
);
